/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateCouponBatchDtoData } from './create-coupon-batch-dto-data';


export interface CreateCouponBatchDto { 
    /**
     * Source of the coupon codes. Shopify batches create codes through a Shopify discount.
     */
    createdFrom: CreateCouponBatchDto.CreatedFromEnum;
    /**
     * Pre-generated batches create their codes ahead of time. On-demand batches (Shopify only) create a Shopify discount code each time a code is assigned or redeemed.
     */
    generationMode?: CreateCouponBatchDto.GenerationModeEnum;
    /**
     * On-demand batches only: days between issuing a code and its expiration. Pre-generated batches use the absolute `data.expiration` instead.
     */
    expiresInDays?: number;
    /**
     * Discount type. The allowed data fields depend on this value.
     */
    discountType: CreateCouponBatchDto.DiscountTypeEnum;
    /**
     * Discount value: a positive amount for fixed discounts, a percentage greater than 0 and up to 100 for percentage discounts, and omitted for free shipping or Buy X Get Y. On-demand fixed batches may omit it when a dynamic reward provides the amount at redeem time.
     */
    value?: number | null;
    data: CreateCouponBatchDtoData;
}
export namespace CreateCouponBatchDto {
    export const CreatedFromEnum = {
        UploadFromCsv: 'upload-from-csv',
        Shopify: 'shopify'
    } as const;
    export type CreatedFromEnum = typeof CreatedFromEnum[keyof typeof CreatedFromEnum];
    export const GenerationModeEnum = {
        PreGenerated: 'pre_generated',
        OnDemand: 'on_demand'
    } as const;
    export type GenerationModeEnum = typeof GenerationModeEnum[keyof typeof GenerationModeEnum];
    export const DiscountTypeEnum = {
        Fixed: 'fixed',
        Percentage: 'percentage',
        FreeShipping: 'free_shipping',
        BuyXGetY: 'buy_x_get_y'
    } as const;
    export type DiscountTypeEnum = typeof DiscountTypeEnum[keyof typeof DiscountTypeEnum];
}


